module.exports = __webpack_public_path__ + "static/media/Stellar Queen Bed Base - 155x205 cm_Light Beige.66c5ff07.png";